import { AppError } from '@naturalcycles/js-lib'
import * as sentry from '@sentry/angular'
import { ErrorEvent } from '@sentry/angular'
import { botReason, isCDP, isE2E } from '@src/app/core/util/e2e.util.js'
import { env } from '@src/environments/environment.js'
import { buildInfo } from './buildInfo.util.js'

const { sentryDsn: dsn, name: environment } = env

const errorGroupings: { message: string; fingerprint: string }[] = [
  {
    fingerprint: 'fbqUnavailable',
    message: 'fbq is not defined',
  },
  {
    fingerprint: 'fbqUnavailable',
    message: "Can't find variable: fbq",
  },
  {
    fingerprint: 'placesAutoCompleteError',
    message: 'PLACES_AUTOCOMPLETE: UNKNOWN_ERROR',
  },
]

/**
 * Used to group commonly occuring errors
 */
const fingerprintError = (err: unknown, event: ErrorEvent): ErrorEvent => {
  if (event.fingerprint) return event // Don't modify if already set
  if (!(err instanceof Error)) return event

  const fingerprint = errorGroupings.find(grouping =>
    err.message.includes(grouping.message),
  )?.fingerprint

  if (!fingerprint) return event

  event.fingerprint = [fingerprint]
  return event
}

export function initSentry(): void {
  sentry.init({
    dsn,
    environment,
    release: buildInfo.ver,
    maxValueLength: 2000, // default is 250 characters,
    normalizeDepth: 10,
    beforeSend: (event, hint) => {
      const ex = hint?.originalException
      // Also helps us group friendly messages that are translated
      if (ex instanceof AppError) {
        if (ex.data.code) {
          event.fingerprint = [ex.data.code]
        } else if (ex.cause?.data.code) {
          event.fingerprint = [ex.cause.data.code]
        }
      }

      return fingerprintError(ex, event)
    },
    ignoreErrors: [/ChunkLoadError/],
  })

  sentry.setTags({
    buildInfo_ver: buildInfo.ver, // eslint-disable-line @typescript-eslint/naming-convention
    buildInfo_env: buildInfo.env, // eslint-disable-line @typescript-eslint/naming-convention
    botReason: botReason || null,
    cdp: isCDP,
    e2e: isE2E(),
  })
}

export { sentry }
